import { AppealStatus } from '@repo/types';

import { useDarkMode } from '@xtnd/web/shared';

import { useAppealStatus } from '../../hooks';

export const ArAppealStatus = ({
  status,
  isStrikeThrough,
}: {
  status: AppealStatus;
  isStrikeThrough?: boolean;
}) => {
  const { isDark } = useDarkMode();
  const mode = isDark ? 'dark' : 'light';
  const { getAppealStatusLabel, getAppealStatusColor } = useAppealStatus(mode);

  const label = getAppealStatusLabel(status);
  const labelColor = getAppealStatusColor(status);

  return (
    <span
      className={`text-sm inline-flex items-center px-2 py-1 rounded-full ${labelColor} truncate ${isStrikeThrough ? 'line-through' : ''}`}
      title={label}
    >
      {label}
    </span>
  );
};
